import { ThinfinityState } from "./interface";

export const initialState: ThinfinityState = {
  hidden: true,
  tittle: '',
  data: {
    userId: null
  }
};